<template>
  <v-container>
    <v-row
      class="mt-5"
      justify="center"
    >
      <v-col :md="6">
        <!-- <v-progress-circular
          v-if="!showCard"
          :size="70"
          :width="7"
          color="purple"
          indeterminate
        ></v-progress-circular> -->
        <v-card
          color="lighten-3"
          v-if="!showCard"
        >
          <v-card-title class="font-weight-bold">
            <v-icon class="mr-1">mdi-alert-decagram-outline</v-icon>
            <span>提示</span>
          </v-card-title>
          <v-card-text class="mt-3">
            <v-row justify="center">
              <p class="text-h4 text--primary">
                交易處理中，
              </p>
              <p class="text-h4 text--primary">
                請稍後．．．．
              </p>
            </v-row>
          </v-card-text>
        </v-card>
        <v-card
          color="lighten-3"
          v-if="showCard && !success"
        >
          <v-card-title class="font-weight-bold">
            <v-icon class="mr-1">mdi-alert-decagram-outline</v-icon>
            <span> {{ noSuccessTitle }}</span>
          </v-card-title>
          <v-card-text>
            <v-row justify="center">
              <p class="text-h4 text--primary">
                {{ noSuccessMsg }}
              </p>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              dark
              color="red lighten-1"
              @click="goHome"
            >
              <span>前往首頁</span>
            </v-btn>
          </v-card-actions>
        </v-card>

        <v-card v-if="showCard && success" min-height="100">
          <v-card-title class="text-h5 font-weight-bold grey lighten-2">
            <v-row justify="center">
              <span>您已完成繳費</span>
            </v-row>
          </v-card-title>

          <v-row justify="center" class="mt-1">
            <v-card-actions>
              <v-btn
                dark
                color="red lighten-1"
                @click="goHome"
              >
                <span>返回繳費查詢頁面</span>
              </v-btn>
            </v-card-actions>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Confirm',
  data: () => ({
    RPOID: '',
    showCard: false,
    success: false,
    timeoutBack: null,
    noSuccessTitle: '交易失敗',
    noSuccessMsg: '交易流程結束，將於10秒後導回首頁',
  }),
  created() {
    this.RPOID = this.$route.query.RPOID;

    if (this.RPOID != null) {
      setTimeout(() => {
        this.goConfirm();
      }, 1000 * 3);
    } else {
      this.showCard = true;
      this.backHome();
    }
  },
  methods: {
    goConfirm() {
      this.dbio(
        '/RentPay/OrderConfirm',
        {
          RPOID: this.RPOID
        },
        'post'
      )
        .then(() => {
          this.showCard = true;
          this.success = true;
        })
        .catch((error) => {
          if(error.request.status === 500){
            this.noSuccessTitle = "付款確認中";
            this.noSuccessMsg = "如有疑問請洽現場管理員，將於10秒後導回首頁。";
          }
          this.showCard = true;
          //this.backHome();
        });
    },
    backHome() {
      this.timeoutBack = setTimeout(() => {
        this.$router.push({ name: 'Charging' });
      }, 1000 * 10);
    },
    goHome() {
      if (this.timeoutBack !== null) {
        clearTimeout(this.timeoutBack);
      }
      this.$router.push({ name: 'Charging' });
    }
  }
};
</script>
